function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="14" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.84 2.016A4.099 4.099 0 0 0 11.037.933a4.099 4.099 0 0 0-2.802 1.083l-.736.687-.736-.687A4.099 4.099 0 0 0 3.962.933 4.099 4.099 0 0 0 1.16 2.016c-1.547 1.445-1.547 3.786 0 5.23l6.34 5.917 6.34-5.917c1.547-1.444 1.547-3.785 0-5.23" fill="#4F5EA3" /></svg>;
});